import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';

export const GET_SEQUENCE_INDEX_STATUS_QUERY_KEY = 'get-sequence-index-status';

export interface SequenceIndexStatusDto {
  index: number;
  frameCount?: number;
  mediaId?: string;
}

export const useGetSequenceIndexStatusQuery = (
  entityRef: string | undefined,
  options?: { enabled?: boolean; refetchInterval?: number | false },
) => {
  const { getToken } = useAuth();
  const enabled = !!entityRef && (options?.enabled ?? true);

  return useQuery({
    queryKey: [GET_SEQUENCE_INDEX_STATUS_QUERY_KEY, entityRef],
    queryFn: async () => {
      const token = await getToken();
      return getSequenceIndexStatus({ token: token ?? '', entityRef: entityRef! });
    },
    enabled,
    refetchInterval: options?.refetchInterval,
  });
};

const getSequenceIndexStatus = async ({
  token,
  entityRef,
}: {
  token: string;
  entityRef: string;
}): Promise<SequenceIndexStatusDto | null> => {
  const url = `${import.meta.env.VITE_API_URL}/player/sequence-index-status?entityRef=${encodeURIComponent(entityRef)}`;
  const data = await sendJSONRequest({ url, method: METHOD.GET, token });
  return (data ?? null) as SequenceIndexStatusDto | null;
};
